import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ "source", "destination" ]

  copy() {
    const inputs = this.destinationTarget.querySelectorAll("input[type=checkbox]")

    inputs.forEach(dst => {
      const src = this.sourceTarget.querySelector(`input[type=checkbox][name="${dst.name}"]`)
      dst.checked = src?.checked
    })

    if (inputs.length) {
      this.dispatch("change", { target: inputs[0], prefix: false })
    }
  }
}
